<template>
    <div
        class="col-sm-12 col-md-6 col-lg-4 col-xl-3 search-card"
        @mouseenter="cardMouseEnter"
        @mouseleave="cardMouseLeave">
        <a class="inner d-none d-sm-block" :class="{ 'box': data.has_giftcard_packages }"
           :href="data.shop_url" :target="openInNewWindow ? '_blank' : '_self'">
            <div class="card-recommended" v-if="data.has_giftcard_packages">
                <span>{{ $t('company.recommended') }}</span>
            </div>

            <div class="search-card-header">
                <img :src="data.preview.tilted" :alt="data.name + `'s cadeaubon`"
                     class="customer-design" width="304" height="149">
                <img src="../../../resources/img/results/envelope.png"
                     alt="Envelope" class="customer-envelope" width="304" height="151">
            </div>

            <div class="search-card-content">
                <h4>{{ data.name }}</h4>

                <div v-if="data.stores.length === 1" class="address">
                    <p class="city">{{ data.stores | storesCity }}</p>
                    <p class="street_zip">{{ data.stores | storesAddress }}</p>
                </div>
                <div class="address" v-if="data.stores.length > 1">
                    <p class="city">{{ data.stores.length}} {{$t('company.returnAddress')}}</p>
                    <p class="street_zip">{{ $t('company.viewReturnAddresses') }}</p>
                </div>

                <div class="button bordered">{{ $t('company.view') }}</div>
                <div id="shipping-from">
                    <span v-if="data.free_delivery_from === 0">{{ $t('company.freeShipping') }}</span>
                    <span v-if="data.free_delivery_from !== null && data.free_delivery_from !== 0">{{ $t('company.freeShippingFrom', {price: data.free_delivery_from / 100}) }}</span>
                </div>
            </div>
        </a>

        <a :href="data.shop_url" class="d-sm-none" :target="openInNewWindow ? '_blank' : '_self'" @click.capture="productClicked">
            <div class="inner d-flex d-sm-none _horizontal">
                <a class="search-card-header" :href="data.shop_url" :target="openInNewWindow ? '_blank' : '_self'">
                    <img :src="data.preview.regular" :alt="data.name + `'s cadeaubon`"
                         class="customer-design">
                </a>

                <div class="search-card-content">
                    <h4>{{ data.name }}</h4>

                    <div class="address">
                        <p class="city">{{ data.stores | storesCity }}</p>
                        <p class="street">{{ data.stores | storesAddress }}</p>
                    </div>

                    <span>{{ data.free_delivery_from | freeDelivery }}</span>
                </div>

                <div>
                    <div :class="{ 'box': data.has_giftcard_packages }">
                        <div class="card-recommended" v-if="data.has_giftcard_packages">
                            <span>{{ $t('company.recommended') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {

    props: {
        data:            {
            type:    Object,
            default: () => {}
        },
        position:        {
            type:    Number,
            default: null
        },
        openInNewWindow: {
            type:    Boolean,
            default: true,
        },
    },

    filters: {
        storesCity (stores) {
            if (stores.length === 1) {
                return stores[0]['city']
            }

            return stores.length + ' inleverpunten'
        },
        storesAddress (stores) {
            if (stores.length === 1) {
                return stores[0]['street'] + ' ' + stores[0]['house_number']
            }

            return 'Inleverpunten bekijken'
        },
        freeDelivery (value) {
            if (value === null) {
                return ''
            }

            if (value === 0) {
                return 'Altijd gratis postverzending'
            }

            return `Gratis postverzending vanaf € ${value / 100}`
        }
    },

    methods: {
        cardMouseEnter (e) {
            e.target.classList.add('_hover')
        },

        cardMouseLeave (e) {
            e.target.classList.remove('_hover')
        },
    }

}
</script>
